import { Routes } from '@angular/router';
import { authGuard } from '@onrsr/ui/auth';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
    },
    {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/pages/dashboard-page/dashboard-page').then(
            (m) => m.DashboardPage,
          ),
        canActivate: [authGuard],
    },
    {
        path: 'occurrences/categorycannualsubmissions',
        loadComponent: () =>
          import('./features/category-c-submission/pages/category-c-submission-list/category-c-submission-list').then(
            (m) => m.CategoryCSubmissionList,
          ),
        canActivate: [authGuard],
    },
    {
        path: 'occurrences/categorycannualsubmissions/:id',
        loadComponent: () =>
          import('./features/category-c-submission/pages/category-c-submission-detail/category-c-submission-detail').then(
            (m) => m.CategoryCSubmissionDetail,
          ),
        canActivate: [authGuard],
    },
    {
        path: 'occurrences/reportnswdatest',
        loadComponent: () =>
          import('./features/report-nsw-da-test/pages/report-nsw-da-test-page/report-nsw-da-test-page').then(
            (m) => m.ReportNswDaTestPage,
          ),
        canActivate: [authGuard],
    },
    {
        path: 'occurrences/export',
        loadComponent: () =>
          import('./features/occurrence-export/pages/occurrence-export-page/occurrence-export-page').then(
            (m) => m.OccurrenceExportPage,
          ),
        canActivate: [authGuard],
    },
    {
        path: 'occurrences/report',
        loadComponent: () =>
          import('./features/occurrence/pages/report-occurrence/report-occurrence').then(
            (m) => m.ReportOccurrence,
          ),
        canActivate: [authGuard],
    },
    {
        path: 'occurrences/:id',
        loadComponent: () =>
          import('./features/occurrence/pages/occurrence-detail/occurrence-detail').then(
            (m) => m.OccurrenceDetail,
          ),
        canActivate: [authGuard],
    },
    {
        path: 'occurrences',
        loadComponent: () =>
          import('./features/occurrence/pages/occurrence-list/occurrence-list').then(
            (m) => m.OccurrenceList,
          ),
        canActivate: [authGuard],
    },
    {
        path: 'ontology/searchlinesections',
        loadComponent: () =>
          import('./features/line-section/pages/line-section-list/line-section-list').then(
            (m) => m.LineSectionList,
          ),
        canActivate: [authGuard],
    },
    {
        path: 'ontology/newlinesection',
        loadComponent: () =>
          import('./features/line-section/pages/line-section-detail/line-section-detail').then(
            (m) => m.LineSectionDetail,
          ),
        data: { mode: 'new' },
        canActivate: [authGuard],
    },
    {
        path: 'ontology/searchlinesections/:id',
        loadComponent: () =>
          import('./features/line-section/pages/line-section-detail/line-section-detail').then(
            (m) => m.LineSectionDetail,
          ),
        canActivate: [authGuard],
    },
    {
        path: 'ontology/searchdefinedlocations',
        loadComponent: () =>
          import('./features/defined-location/pages/defined-location-list/defined-location-list').then(
            (m) => m.DefinedLocationList,
          ),
        canActivate: [authGuard],
    },
    {
        path: 'ontology/newdefinedlocation',
        loadComponent: () =>
          import('./features/defined-location/pages/defined-location-detail/defined-location-detail').then(
            (m) => m.DefinedLocationDetail,
          ),
        data: { mode: 'new' },
        canActivate: [authGuard],
    },
    {
        path: 'ontology/searchdefinedlocations/:id',
        loadComponent: () =>
          import('./features/defined-location/pages/defined-location-detail/defined-location-detail').then(
            (m) => m.DefinedLocationDetail,
          ),
        canActivate: [authGuard],
    },
    {
        path: 'ontology/searchlevelcrossingsites',
        loadComponent: () =>
          import('./features/level-crossing-site/pages/level-crossing-site-list/level-crossing-site-list').then(
            (m) => m.LevelCrossingSiteList,
          ),
        canActivate: [authGuard],
    },
    {
        path: 'ontology/networkdata',
        loadComponent: () =>
          import('./features/network-data/pages/network-data-page/network-data-page').then(
            (m) => m.NetworkDataPage,
          ),
        canActivate: [authGuard],
    },
    {
        path: 'ontology/newlevelcrossingsite',
        loadComponent: () =>
          import('./features/level-crossing-site/pages/level-crossing-site-detail/level-crossing-site-detail').then(
            (m) => m.LevelCrossingSiteDetail,
          ),
        data: { mode: 'new' },
        canActivate: [authGuard],
    },
    {
        path: 'ontology/searchlevelcrossingsites/:id',
        loadComponent: () =>
          import('./features/level-crossing-site/pages/level-crossing-site-detail/level-crossing-site-detail').then(
            (m) => m.LevelCrossingSiteDetail,
          ),
        canActivate: [authGuard],
    },
    {
        path: 'notificationofchange',
        loadComponent: () =>
          import('./features/notification-of-change/pages/notification-of-change-list/notification-of-change-list').then(
            (m) => m.NotificationOfChangeList,
          ),
        canActivate: [authGuard],
    },
    {
        path: 'notificationofchange/new',
        loadComponent: () =>
          import('./features/notification-of-change/pages/notification-of-change-new/notification-of-change-new').then(
            (m) => m.NotificationOfChangeNew,
          ),
        canActivate: [authGuard],
    },
    {
        path: 'notificationofchange/:id',
        loadComponent: () =>
          import('./features/notification-of-change/pages/notification-of-change-detail/notification-of-change-detail').then(
            (m) => m.NotificationOfChangeDetail,
          ),
        canActivate: [authGuard],
    },
    {
        path: 'organisation-profile',
        loadComponent: () =>
          import('./features/organisation-profile/pages/organisation-profile-page/organisation-profile-page').then(
            (m) => m.OrganisationProfilePage,
          ),
        canActivate: [authGuard],
    },
    {
        path: 'organisation/portal-users',
        loadComponent: () =>
          import('./features/onrsr-portal-user/pages/onrsr-portal-user-list/onrsr-portal-user-list').then(
            (m) => m.OnrsrPortalUserList,
          ),
        canActivate: [authGuard],
    },
    {
        path: 'organisation/portal-users/new',
        loadComponent: () =>
          import('./features/onrsr-portal-user/pages/onrsr-portal-user-detail/onrsr-portal-user-detail').then(
            (m) => m.OnrsrPortalUserDetail,
          ),
        data: { mode: 'new' },
        canActivate: [authGuard],
    },
    {
        path: 'organisation/portal-users/:id',
        loadComponent: () =>
          import('./features/onrsr-portal-user/pages/onrsr-portal-user-detail/onrsr-portal-user-detail').then(
            (m) => m.OnrsrPortalUserDetail,
          ),
        canActivate: [authGuard],
    },
    {
        path: 'myorganisation',
        redirectTo: 'organisation-profile',
        pathMatch: 'full',
    },
  {
    path: 'monthlyreturns',
    redirectTo: 'monthlyreturns/searchmonthlyreturns',
    pathMatch: 'full',
  },
  {
    path: 'monthlyreturns/searchmonthlyreturns',
    loadComponent: () =>
      import('./features/monthly-return/pages/monthly-return-list/monthly-return-list').then(
        (m) => m.MonthlyReturnList,
      ),
    canActivate: [authGuard],
  },
  {
    path: 'monthlyreturns/:id',
    loadComponent: () =>
      import('./features/monthly-return/pages/monthly-return-detail/monthly-return-detail').then(
        (m) => m.MonthlyReturnDetail,
      ),
    canActivate: [authGuard],
  },
  {
    path: 'annualreturns/searchannualreturns',
    loadComponent: () =>
      import('./features/annual-return/pages/annual-return-list/annual-return-list').then(
        (m) => m.AnnualReturnList,
      ),
    canActivate: [authGuard],
  },
  {
    path: 'annualreturns/:id',
    loadComponent: () =>
      import('./features/annual-return/pages/annual-return-detail/annual-return-detail').then(
        (m) => m.AnnualReturnDetail,
      ),
    canActivate: [authGuard],
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./core/auth/pages/login/login').then((m) => m.Login),
  },
  {
    path: 'mapbox-demo',
    loadComponent: () =>
      import('./features/mapbox-demo/pages/mapbox-demo-page/mapbox-demo-page').then(
        (m) => m.MapboxDemoPage,
      ),
    canActivate: [authGuard],
  },
  {
    path: 'openstreetmap-demo',
    loadComponent: () =>
      import('./features/openstreetmap-demo/pages/openstreetmap-demo-page/openstreetmap-demo-page').then(
        (m) => m.OpenstreetmapDemoPage,
      ),
    canActivate: [authGuard],
  },
];
